import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { getQuickLinksRequest, getQuickLinksSuccess } from '../../slices/user';

function* getQuickLinksWorker() {
  try {
    const { usefulLinks, isLoggedIn } = yield select((store) => store.user);
    if (isLoggedIn && !usefulLinks) {
      const url = 'users/cruiseImportantLinks';
      const config = {
        method: 'GET',
        url,
      };
      const { data } = yield call(axios, config);
      yield put(getQuickLinksSuccess({ data }));
    }
  } catch (error) {
    yield put(getQuickLinksSuccess({}));
    console.error(error);
  }
}

function* getQuickLinksWatcher() {
  yield takeLatest(getQuickLinksRequest.toString(), getQuickLinksWorker);
}

export default getQuickLinksWatcher;
